import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import JobCompleteConfirmContainer from "@legacy/jobs/JobCompleteConfirmContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { useJobsBackDestination } from "@pages/Jobs/Jobs.store"

import { JOBS_ROUTES } from "@routes/jobs"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function JobCompleteSummary() {
    const isDesktop = useIsDesktop()

    const jobId = window.JOB_ID

    const [listRoute, detailsRoute] = useSlugExtractor([JOBS_ROUTES.LIST, JOBS_ROUTES.DETAILS], jobId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const cleanedJobsListRoute = useJobsBackDestination(listRoute)

    const listBackDestination = hasPermission("jobs_list_permission", PERMISSION_LEVEL.FULL)
        ? cleanedJobsListRoute
        : undefined
    const detailsBackDestination = hasPermission("jobs_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root pageId="JobCompletedSummaryConfirmation">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Jobs"
                            icon={icon({ name: "wrench-simple", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "wrench-simple", style: "solid", family: "sharp" })}
                            destination={listBackDestination}
                            iconOnly={!isDesktop}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle label="Summary Confirmation" backDestination={detailsBackDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <JobCompleteConfirmContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
